export const getCartDate = () => {
  const cartDate = localStorage.getItem('cartDate'); // Retrieve the cartDate from localStorage.
  return cartDate;
};

export { getCartDate as default };
